import '../../resources/css/site/ModalSiteDetail.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Modal } from 'react-bootstrap';
import { closeModal } from '../../actions/index';
import SiteForm from './SiteForm';


class ModalSiteDetail extends Component {
    
    render() {
        const { closeModal, modalStatus, modalMessage, modelOrgDetail } = this.props;
        let show = modalStatus === 'modelOrganization';
        let classModal = 'modal-site-details';
        let renderContent;

        if (show) {
            let modalTitle, modalContentCss = 'modal-content';
            if (modalMessage === 'add') {
                // add
                modalTitle = "Add new site";
                modalContentCss += " modal-content-secondary"
            } else if (modalMessage === 'upd') {
                // edit
                modalTitle = "Edit";
                modalContentCss = " modal-content-secondary"
            } else {
                // readonly
                modalTitle = modelOrgDetail.name;
                classModal += ' readonly-form';
            }

            renderContent = (
                <Modal
                    show={show}
                    dialogClassName={ classModal }
                    centered
                    onHide={() => closeModal(null)}
                    contentClassName = {modalContentCss}
                    onShow={this.openOrgModal}
                >
                    <Modal.Body>
                        <div className='area-modal-detail-header'>
                            <Row>
                                <Col sm={6} className='area-modal-title'>
                                    <span className='icon-model-settings-white'></span><label>{ modalTitle }</label>
                                </Col>
                                <Col sm={6} className='area-close-btn'>
                                    <span className='area-icon-close-detail' onClick={() => closeModal(null)}><span className="icon-btn-close-n"></span></span>
                                </Col>
                            </Row>
                        </div>
                        <div className='area-modal-detail-content'>
                            <SiteForm></SiteForm>
                        </div>
                    </Modal.Body>
                </Modal>
            )        
        } else {
            renderContent = (<div className='modal-detail-empty'></div>);
        }

        return (
            <div className='area-site-detail'>
                {renderContent}
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        modalStatus: state.commonReducers.modalStatus,
        modalMessage: state.commonReducers.modalMessage,
        modelOrgDetail: state.modelReducers.modelOrgDetail
    }
}

export default connect(
    mapStateToProps,
    { closeModal }
)(ModalSiteDetail)

